var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.475 12.702-7.89 8.009a.93.93 0 0 1-.692.289.93.93 0 0 1-.692-.289l-.895-.908a1.04 1.04 0 0 1-.305-.702.9.9 0 0 1 .265-.702L13.57 12 7.266 5.6A.9.9 0 0 1 7 4.9a1.04 1.04 0 0 1 .305-.703l.895-.908A.93.93 0 0 1 8.893 3q.405 0 .691.289l7.89 8.01A.9.9 0 0 1 17.8 12q0 .413-.325.702"
  })));
};
export default SvgChevronRight;